import { FC } from 'react';
import { DetailsBooking } from 'types';
import { FLAG_UPDATE_PAYMENT_METHOD } from 'config';
import * as track from 'lib/gaTracking/crossPageEvents';

import ItemLinks from 'components/ItemLinks';
import compact from 'lodash/compact';

interface LinksProps {
  booking: DetailsBooking;
}

const Links: FC<LinksProps> = ({ booking }) => {
  const { isAfterCheckOut } = booking.reservation;
  const { isFinalising, isCreditCardExpired } = booking.flags;

  const rebookLink = {
    label: 'Book again',
    url: booking.links.rebook,
    external: true,
    onClick: track.bookAgainLink,
    'data-testid': 'rebook-link',
  };

  // Temporarily disable Update Payment Methods Feature
  const updatePaymentMethodLink = FLAG_UPDATE_PAYMENT_METHOD &&
    isCreditCardExpired &&
    !isAfterCheckOut &&
    !isFinalising && {
      label: 'Update credit card',
      url: booking.links.updatePaymentMethod,
      external: true,
      onClick: track.updatePaymentMethodLink,
      'data-testid': 'update-payment-method-link',
    };

  const printItineraryLink = !isFinalising && {
    label: 'Print itinerary',
    url: booking.links.print,
    external: true,
    target: '_blank',
    onClick: track.printItineraryLink,
    'data-testid': 'print-itinerary-link',
  };

  return <ItemLinks links={compact([rebookLink, updatePaymentMethodLink, printItineraryLink])} height="100%" width="100%" />;
};

export default Links;
